import React from 'react';
import Image from 'next/image';
import { InfographicImg } from './styled';

export default function InfographicImage(props) {
  const { data, altDescription } = props;

  return (
    <InfographicImg>
      <Image
        src={data[0]}
        alt={altDescription}
        quality={90}
        priority={true}
        fill
        sizes="90vw"
      />
    </InfographicImg>
  );
}
